// ---------------------------
// Full JavaScript Code
// ---------------------------
const v = "GraphQL Client";
const D =
  "An error occurred while fetching from the API. Review 'graphQLErrors' for details.";
const U = "Response returned unexpected Content-Type:";
const k =
  "An unknown error has occurred. The API did not return a data object or any errors in its response.";
const $ = { json: "application/json", multipart: "multipart/mixed" };
const I = "X-SDK-Variant";
const _ = "X-SDK-Version";
const X = "shopify-graphql-client";
const W = "0.10.3";
const L = 1000;
const J = [429, 503];
const F = /@(defer)\b/i;
const O = `\r
`;
const Y = /boundary="?([^=";]+)"?/i;
const P = O + O;

// Utility: prefix error messages, etc.
function m(r, e = v) {
  return r.startsWith(`${e}`) ? r : `${e}: ${r}`;
}
function w(r) {
  return r instanceof Error ? r.message : JSON.stringify(r);
}
function H(r) {
  return r instanceof Error && r.cause ? r.cause : void 0;
}
function q(r) {
  return r.flatMap(({ errors: e }) => e ?? []);
}
function j({ client: r, retries: e }) {
  if (e !== void 0 && (typeof e != "number" || e < 0 || e > 3))
    throw new Error(
      `${r}: The provided "retries" value (${e}) is invalid - it cannot be less than 0 or greater than 3`
    );
}
function p(r, e) {
  return e &&
    (typeof e != "object" ||
      Array.isArray(e) ||
      (typeof e == "object" && Object.keys(e).length > 0))
    ? { [r]: e }
    : {};
}
function B(r, e) {
  if (r.length === 0) return e;
  const n = { [r.pop()]: e };
  return r.length === 0 ? n : B(r, n);
}
function K(r, e) {
  return Object.keys(e || {}).reduce(
    (t, n) =>
      (typeof e[n] == "object" || Array.isArray(e[n])) && r[n]
        ? ((t[n] = K(r[n], e[n])), t)
        : ((t[n] = e[n]), t),
    Array.isArray(r) ? [...r] : { ...r }
  );
}
function M([r, ...e]) {
  return e.reduce(K, { ...r });
}
function z({
  clientLogger: r,
  customFetchApi: e = fetch,
  client: t = v,
  defaultRetryWaitTime: n = L,
  retriableCodes: s = J,
}) {
  const a = async (c, o, i) => {
    const l = o + 1,
      d = i + 1;
    let u;
    try {
      u = await e(...c);
      r({
        type: "HTTP-Response",
        content: { requestParams: c, response: u },
      });
      if (!u.ok && s.includes(u.status) && l <= d) {
        throw new Error();
      }
      return u;
    } catch (f) {
      if (l <= d) {
        const h = u == null ? void 0 : u.headers.get("Retry-After");
        await Z(h ? parseInt(h, 10) : n);
        r({
          type: "HTTP-Retry",
          content: {
            requestParams: c,
            lastResponse: u,
            retryAttempt: o,
            maxRetries: i,
          },
        });
        return a(c, l, i);
      }
      throw new Error(
        m(
          `${
            i > 0
              ? `Attempted maximum number of ${i} network retries. Last message - `
              : ""
          }${w(f)}`,
          t
        )
      );
    }
  };
  return a;
}
async function Z(r) {
  return new Promise((e) => setTimeout(e, r));
}
function ee({
  headers: r,
  url: e,
  customFetchApi: t = fetch,
  retries: n = 0,
  logger: s,
}) {
  j({ client: v, retries: n });
  const a = { headers: r, url: e, retries: n },
    c = te(s),
    o = z({ customFetchApi: t, clientLogger: c, defaultRetryWaitTime: L }),
    i = re(o, a),
    l = ne(i),
    d = ue(i);
  return { config: a, fetch: i, request: l, requestStream: d };
}
function te(r) {
  return (e) => {
    r && r(e);
  };
}
async function V(r) {
  const { errors: e, data: t, extensions: n } = await r.json();
  return {
    ...p("data", t),
    ...p("extensions", n),
    ...(e || !t
      ? {
          errors: {
            networkStatusCode: r.status,
            message: m(e ? D : k),
            ...p("graphQLErrors", e),
            response: r,
          },
        }
      : {}),
  };
}
function re(r, { url: e, headers: t, retries: n }) {
  return async (s, a = {}) => {
    const { variables: c, headers: o, url: i, retries: l } = a,
      d = JSON.stringify({ query: s, variables: c });

    j({ client: v, retries: l });
    const u = Object.entries({ ...t, ...o }).reduce((h, [E, y]) => {
      h[E] = Array.isArray(y) ? y.join(", ") : y.toString();
      return h;
    }, {});

    if (!u[I] && !u[_]) {
      u[I] = X;
      u[_] = W;
    }
    return r([i ?? e, { method: "POST", headers: u, body: d }], 1, l ?? n);
  };
}
function ne(r) {
  return async (...e) => {
    if (F.test(e[0])) {
      throw new Error(
        m(
          "This operation will result in a streamable response - use requestStream() instead."
        )
      );
    }
    try {
      const t = await r(...e),
        { status: n, statusText: s } = t,
        a = t.headers.get("content-type") || "";

      return t.ok
        ? a.includes($.json)
          ? V(t)
          : {
              errors: {
                networkStatusCode: n,
                message: m(`${U} ${a}`),
                response: t,
              },
            }
        : { errors: { networkStatusCode: n, message: m(s), response: t } };
    } catch (t) {
      return { errors: { message: w(t) } };
    }
  };
}
async function* se(r) {
  const e = new TextDecoder();
  if (r.body[Symbol.asyncIterator]) {
    for await (const t of r.body) {
      yield e.decode(t);
    }
  } else {
    const t = r.body.getReader();
    try {
      let n;
      while (!(n = await t.read()).done) {
        yield e.decode(n.value);
      }
    } finally {
      t.cancel();
    }
  }
}
function oe(r, e) {
  return {
    async *[Symbol.asyncIterator]() {
      try {
        let t = "";
        for await (const n of r) {
          t += n;
          if (t.indexOf(e) > -1) {
            const s = t.lastIndexOf(e),
              c = t
                .slice(0, s)
                .split(e)
                .filter((o) => o.trim().length > 0)
                .map((o) => o.slice(o.indexOf(P) + P.length).trim());
            if (c.length > 0) yield c;
            t = t.slice(s + e.length);
            if (t.trim() === "--") t = "";
          }
        }
      } catch (t) {
        throw new Error(
          `Error occured while processing stream payload - ${w(t)}`
        );
      }
    },
  };
}
function ie(r) {
  return {
    async *[Symbol.asyncIterator]() {
      yield { ...(await V(r)), hasNext: !1 };
    },
  };
}
function ae(r) {
  return r
    .map((e) => {
      try {
        return JSON.parse(e);
      } catch (t) {
        throw new Error(`Error in parsing multipart response - ${w(t)}`);
      }
    })
    .map((e) => {
      const {
        data: t,
        incremental: n,
        hasNext: s,
        extensions: a,
        errors: c,
      } = e;
      if (!n) {
        return {
          data: t || {},
          ...p("errors", c),
          ...p("extensions", a),
          hasNext: s,
        };
      }
      const o = n.map(({ data: i, path: l, errors: d }) => ({
        data: i && l ? B(l, i) : {},
        ...p("errors", d),
      }));
      return {
        data: o.length === 1 ? o[0].data : M([...o.map(({ data: i }) => i)]),
        ...p("errors", q(o)),
        hasNext: s,
      };
    });
}
function ce(r, e) {
  if (r.length > 0) {
    throw new Error(D, { cause: { graphQLErrors: r } });
  }
  if (Object.keys(e).length === 0) {
    throw new Error(k);
  }
}
function le(r, e) {
  const t = (e ?? "").match(Y),
    n = `--${t ? t[1] : "-"}`;

  if (!r.body?.getReader && !r.body[Symbol.asyncIterator]) {
    throw new Error("API multipart response did not return an iterable body", {
      cause: r,
    });
  }
  const s = se(r);
  let a = {},
    c;

  return {
    async *[Symbol.asyncIterator]() {
      try {
        let l = !0;
        for await (const d of oe(s, n)) {
          const u = ae(d);
          c = u.find((h) => h.extensions)?.extensions ?? c;
          const f = q(u);
          a = M([a, ...u.map(({ data: h }) => h)]);
          l = u.slice(-1)[0].hasNext;
          ce(f, a);
          yield { ...p("data", a), ...p("extensions", c), hasNext: l };
        }
        if (l) {
          throw new Error("Response stream terminated unexpectedly");
        }
      } catch (l) {
        const d = H(l);
        yield {
          ...p("data", a),
          ...p("extensions", c),
          errors: {
            message: m(w(l)),
            networkStatusCode: r.status,
            ...p("graphQLErrors", d?.graphQLErrors),
            response: r,
          },
          hasNext: !1,
        };
      }
    },
  };
}
function ue(r) {
  return async (...e) => {
    if (!F.test(e[0])) {
      throw new Error(
        m(
          "This operation does not result in a streamable response - use request() instead."
        )
      );
    }
    try {
      const t = await r(...e),
        { statusText: n } = t;
      if (!t.ok) {
        throw new Error(n, { cause: t });
      }
      const s = t.headers.get("content-type") || "";
      switch (true) {
        case s.includes($.json):
          return ie(t);
        case s.includes($.multipart):
          return le(t, s);
        default:
          throw new Error(`${U} ${s}`, { cause: t });
      }
    } catch (t) {
      return {
        async *[Symbol.asyncIterator]() {
          const n = H(t);
          yield {
            errors: {
              message: m(w(t)),
              ...p("networkStatusCode", n?.status),
              ...p("response", n),
            },
            hasNext: !1,
          };
        },
      };
    }
  };
}
function de({ client: r, storeDomain: e }) {
  try {
    if (!e || typeof e !== "string") {
      throw new Error();
    }
    const t = e.trim(),
      n = t.match(/^https?:/) ? t : `https://${t}`,
      s = new URL(n);
    s.protocol = "https";
    return s.origin;
  } catch {
    throw new Error(`${r}: a valid store domain ("${e}") must be provided`);
  }
}
function G({
  client: r,
  currentSupportedApiVersions: e,
  apiVersion: t,
  logger: n,
}) {
  const s = `${r}: the provided apiVersion ("${t}")`,
    a = `Currently supported API versions: ${e.join(", ")}`;
  if (!t || typeof t !== "string") {
    throw new Error(`${s} is invalid. ${a}`);
  }
  const c = t.trim();
  if (!e.includes(c)) {
    n
      ? n({
          type: "Unsupported_Api_Version",
          content: { apiVersion: t, supportedApiVersions: e },
        })
      : console.warn(`${s} is likely deprecated or not supported. ${a}`);
  }
}
function b(r) {
  const e = r * 3 - 2;
  return e === 10 ? e : `0${e}`;
}
function T(r, e, t) {
  const n = e - t;
  return n <= 0 ? `${r - 1}-${b(n + 4)}` : `${r}-${b(n)}`;
}
function he() {
  const r = new Date(),
    e = r.getUTCMonth(),
    t = r.getUTCFullYear(),
    n = Math.floor(e / 3 + 1);
  return { year: t, quarter: n, version: `${t}-${b(n)}` };
}
function pe() {
  const { year: r, quarter: e, version: t } = he(),
    n = e === 4 ? `${r + 1}-01` : `${r}-${b(e + 1)}`;
  return [T(r, e, 3), T(r, e, 2), T(r, e, 1), t, n, "unstable"];
}
function fe(r) {
  return (e) => ({ ...(e ?? {}), ...r.headers });
}
function ye({ getHeaders: r, getApiUrl: e }) {
  return (t, n) => {
    const s = [t];
    if (n && Object.keys(n).length > 0) {
      const { variables: a, apiVersion: c, headers: o, retries: i } = n;
      s.push({
        ...(a ? { variables: a } : {}),
        ...(o ? { headers: r(o) } : {}),
        ...(c ? { url: e(c) } : {}),
        ...(i ? { retries: i } : {}),
      });
    }
    return s;
  };
}
const C = "application/json";
const me = "storefront-api-client";
const Ee = "0.3.3";
const ge = "X-Shopify-Storefront-Access-Token";
const we = "Shopify-Storefront-Private-Token";
const Ae = "X-SDK-Variant";
const Re = "X-SDK-Version";
const Se = "X-SDK-Variant-Source";
const S = "Storefront API Client";

function be(r) {
  if (r && typeof window < "u")
    throw new Error(
      `${S}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`
    );
}
function ve(r, e) {
  if (!r && !e)
    throw new Error(`${S}: a public or private access token must be provided`);
  if (r && e)
    throw new Error(
      `${S}: only provide either a public or private access token`
    );
}
function Te({
  storeDomain: r,
  apiVersion: e,
  publicAccessToken: t,
  privateAccessToken: n,
  clientName: s,
  retries: a = 0,
  customFetchApi: c,
  logger: o,
}) {
  const i = pe();
  const l = de({ client: S, storeDomain: r });
  const d = { client: S, currentSupportedApiVersions: i, logger: o };
  G({ ...d, apiVersion: e });
  ve(t, n);
  be(n);

  const u = $e(l, e, d);
  const f = {
    storeDomain: l,
    apiVersion: "2025-04",
    ...(t ? { publicAccessToken: t } : { privateAccessToken: n }),
    headers: {
      "Content-Type": C,
      Accept: C,
      [Ae]: me,
      [Re]: Ee,
      ...(s ? { [Se]: s } : {}),
      ...(t ? { [ge]: t } : { [we]: n }),
    },
    apiUrl: u(),
    clientName: s,
  };
  const h = ee({
    headers: f.headers,
    url: f.apiUrl,
    retries: a,
    customFetchApi: c,
    logger: o,
  });
  const E = fe(f);
  const y = Ie(f, u);
  const g = ye({ getHeaders: E, getApiUrl: y });

  return Object.freeze({
    config: f,
    getHeaders: E,
    getApiUrl: y,
    fetch: (...R) => h.fetch(...g(...R)),
    request: (...R) => h.request(...g(...R)),
    requestStream: (...R) => h.requestStream(...g(...R)),
  });
}
function $e(r, e, t) {
  return (n) => {
    n && G({ ...t, apiVersion: n });
    const s = (n ?? e).trim();
    return `${r}/api/${s}/graphql.json`;
  };
}
function Ie(r, e) {
  return (t) => (t ? e(t) : r.apiUrl);
}

// Actual Storefront client
const _e = Te({
  storeDomain: "https://weareonecomposites.myshopify.com",
  apiVersion: "2025-07", // Updated to most recent version supported by Shopify
  publicAccessToken: "a315a9b6f534f4b2ed483eb279323c75",
});

// Helper to read nodes
function Oe(r) {
  return r != null && r.edges ? r.edges.map((e) => e.node) : [];
}

// fetchRules can get wheelset_rule or rim_rule
async function fetchRules(ruleType = "wheelset_rule", handleFilter = "") {
  let results = [];
  let hasMore = true;
  let cursor = null;

  while (hasMore) {
    const { data, errors } = await _e.request(
      `query GetBuilderRules($type: String!, $entryCount: Int!, $cursor: String) {
        metaobjects(type: $type, first: $entryCount, after: $cursor) {
          edges {
            node {
              handle
              type
              fields {
                key
                value
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`,
      {
        variables: {
          type: ruleType,
          entryCount: 250,
          cursor,
        },
      }
    );

    if (errors) {
      return { errors };
    }

    const { metaobjects } = data ?? {};
    const { edges, pageInfo } = metaobjects ?? {};
    if (edges) {
      results = results.concat(edges.map((edge) => edge.node));
    }
    hasMore = pageInfo?.hasNextPage;
    cursor = pageInfo?.endCursor;
  }

  // Filter results based on type and handle
  if (handleFilter) {
    results = results.filter(
      (obj) =>
        obj.handle.toLowerCase().includes(handleFilter.toLowerCase()) &&
        obj.type === ruleType
    );
  }

  return { rules: results };
}

// Fetch hub inventory information from metaobjects
async function fetchHubInventory(
  hubModel,
  brakeType,
  frontSpacing,
  rearSpacing,
  buildType = "complete",
  frontRim = "",
  rearRim = ""
) {
  let results = [];
  let hasMore = true;
  let cursor = null;

  // Format query parameters for consistency - normalize by trimming and lowercasing
  const queryParams = {
    hubModel: hubModel?.toLowerCase().trim() || "",
    brakeType: brakeType?.toLowerCase().trim() || "",
    frontSpacing: frontSpacing?.toLowerCase().trim() || "",
    rearSpacing: rearSpacing?.toLowerCase().trim() || "",
    buildType: buildType?.toLowerCase().trim() || "complete",
    frontRim: frontRim?.toLowerCase().trim() || "",
    rearRim: rearRim?.toLowerCase().trim() || "",
  };

  // Extract the rim model from URL path
  function getRimModelFromUrl() {
    // List of all possible rim models we're looking for
    const rimModels = [
      "sector",
      "triad",
      "fuse",
      "faction",
      "union",
      "strife",
      "coup",
      "convert",
    ];

    // Get the current URL pathname and split it into segments
    const pathSegments = window.location.pathname
      .toLowerCase()
      .split("/")
      .filter(Boolean);

    // Look for any segment that matches our rim models
    for (const segment of pathSegments) {
      if (rimModels.includes(segment)) {
        console.log(`Detected rim model from URL: ${segment}`);
        return segment;
      }
    }

    // If no direct match, check if any segment contains our rim models
    for (const segment of pathSegments) {
      for (const model of rimModels) {
        if (segment.includes(model)) {
          console.log(`Detected rim model from URL (partial match): ${model}`);
          return model;
        }
      }
    }

    return null;
  }

  // Add rim model from URL to query parameters
  const urlRimModel = getRimModelFromUrl();
  if (urlRimModel) {
    queryParams.urlRimModel = urlRimModel;
  }

  // Fetch hub inventory metaobjects
  while (hasMore) {
    const { data, errors } = await _e.request(
      `query GetHubInventory($type: String!, $entryCount: Int!, $cursor: String) {
        metaobjects(type: $type, first: $entryCount, after: $cursor) {
          edges {
            node {
              handle
              type
              fields {
                key
                value
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`,
      {
        variables: {
          type: "hub_inventory",
          entryCount: 250,
          cursor,
        },
      }
    );

    if (errors) {
      return { errors };
    }

    const { metaobjects } = data ?? {};
    const { edges, pageInfo } = metaobjects ?? {};
    if (edges) {
      results = results.concat(edges.map((edge) => edge.node));
    }
    hasMore = pageInfo?.hasNextPage;
    cursor = pageInfo?.endCursor;
  }

  // Helper function to normalize and compare strings
  function normalizeAndCompare(str1, str2) {
    // Handle null/undefined values
    if (!str1 || !str2) return false;

    // Handle JSON array strings in metaobject fields (format: ["value"])
    let normalizedStr1 = str1;
    try {
      // Check if str1 is a JSON array string
      if (str1.trim().startsWith("[") && str1.trim().endsWith("]")) {
        const parsed = JSON.parse(str1);
        if (Array.isArray(parsed) && parsed.length > 0) {
          normalizedStr1 = parsed[0]; // Use the first value in the array
        }
      }
    } catch (e) {
      // Continue with original string if parsing fails
    }

    // Normalize strings: lowercase, trim, remove extra spaces, normalize hyphens/dashes
    const normalize = (s) =>
      s.toLowerCase().trim().replace(/\s+/g, " ").replace(/[-–—]/g, "-");

    // Compare normalized strings
    return normalize(normalizedStr1) === normalize(str2);
  }

  // Filter hub inventory metaobjects based on selected options with more flexible matching
  // and considering the build type
  const matchingHubs = results.filter((hub) => {
    const hubFields = {};
    hub.fields.forEach((field) => {
      hubFields[field.key] = field.value;
    });

    // More flexible matching logic - apply different rules based on build type
    const matchModel =
      !queryParams.hubModel ||
      normalizeAndCompare(hubFields.hub_model, queryParams.hubModel);

    const matchBrake =
      !queryParams.brakeType ||
      normalizeAndCompare(hubFields.brake_type, queryParams.brakeType);

    // Check if rim model from URL matches the hub's rim model field (if both exist)
    const matchRimModel =
      // If no URL rim model specified, no need to match on rim model
      !queryParams.urlRimModel ||
      // If URL rim model exists and hub has rim_model field, verify they match
      (hubFields.rim_model &&
        normalizeAndCompare(hubFields.rim_model, queryParams.urlRimModel));

    // For front-only builds, we only care about front spacing and front rim (if specified)
    // For rear-only builds, we only care about rear spacing and rear rim (if specified)
    // For complete builds, we care about both
    let matchFront = true;
    let matchRear = true;
    let matchFrontRim = true;
    let matchRearRim = true;

    if (
      queryParams.buildType === "front" ||
      queryParams.buildType === "complete"
    ) {
      // Match front spacing if building front or complete wheelset
      matchFront =
        !queryParams.frontSpacing ||
        normalizeAndCompare(hubFields.front_spacing, queryParams.frontSpacing);

      // Match front rim if it's specified and we're building front or complete
      if (queryParams.frontRim && hubFields.front_rim) {
        matchFrontRim = normalizeAndCompare(
          hubFields.front_rim,
          queryParams.frontRim
        );
      }
    }

    if (
      queryParams.buildType === "rear" ||
      queryParams.buildType === "complete"
    ) {
      // Match rear spacing if building rear or complete wheelset
      matchRear =
        !queryParams.rearSpacing ||
        normalizeAndCompare(hubFields.rear_spacing, queryParams.rearSpacing);

      // Match rear rim if it's specified and we're building rear or complete
      if (queryParams.rearRim && hubFields.rear_rim) {
        matchRearRim = normalizeAndCompare(
          hubFields.rear_rim,
          queryParams.rearRim
        );
      }
    }

    // Include rim model match in the final determination
    return (
      matchModel &&
      matchBrake &&
      matchRimModel &&
      matchFront &&
      matchRear &&
      matchFrontRim &&
      matchRearRim
    );
  });

  // Modified to collect all base handles from all matching hubs
  const baseHandles = [];
  matchingHubs.forEach((hub) => {
    const hubFields = {};
    hub.fields.forEach((field) => {
      hubFields[field.key] = field.value;
    });

    // Determine which handles to use based on build type
    let handlesToUse = [];

    if (queryParams.buildType === "front") {
      // For front wheels, use front_product_handle if it exists, otherwise fall back to product_handle
      const frontHandle =
        hubFields.front_product_handle || hubFields.product_handle;
      if (frontHandle)
        handlesToUse.push({ key: "front_product_handle", value: frontHandle });
    } else if (queryParams.buildType === "rear") {
      // For rear wheels, use rear_product_handle if it exists, otherwise fall back to product_handle
      const rearHandle =
        hubFields.rear_product_handle || hubFields.product_handle;
      if (rearHandle)
        handlesToUse.push({ key: "rear_product_handle", value: rearHandle });
    } else {
      // For complete wheels, use both front_product_handle and rear_product_handle if they exist
      // Otherwise fall back to product_handle for both
      const frontHandle =
        hubFields.front_product_handle || hubFields.product_handle;
      const rearHandle =
        hubFields.rear_product_handle || hubFields.product_handle;

      if (frontHandle)
        handlesToUse.push({ key: "front_product_handle", value: frontHandle });
      if (rearHandle)
        handlesToUse.push({ key: "rear_product_handle", value: rearHandle });
    }

    // Process each handle
    handlesToUse.forEach(({ key, value }) => {
      // Parse JSON array strings properly
      let handleValue = value.trim();
      try {
        // Check if the value is a JSON array string
        if (handleValue.startsWith("[") && handleValue.endsWith("]")) {
          const parsed = JSON.parse(handleValue);
          if (Array.isArray(parsed) && parsed.length > 0) {
            handleValue = parsed[0].trim();
          }
        }
      } catch (e) {
        // Continue with original string if parsing fails
      }

      // Add to base handles if not already there
      if (!baseHandles.includes(handleValue)) {
        baseHandles.push(handleValue);
      }
    });
  });

  // Define mapping between UI color names and handle suffixes
  const colorHandleMap = {
    Black: "black",
    Silver: "silver",
    Gold: "gold",
    Orange: "orange",
    Purple: "purple",
    Green: "green",
    Red: "red",
    Bronze: "bronze",
    Turquoise: "turquoise",
    Blue: "blue",
    Maple: "maple",
    Pink: "pink",
  };

  // Full list of available hub colors from the UI
  const allColors = [
    "Black",
    "Silver",
    "Gold",
    "Orange",
    "Purple",
    "Green",
    "Red",
    "Bronze",
    "Turquoise",
    "Blue",
    "Maple",
    "Pink",
  ];

  // Now check availability for all color variants of these products
  const colorInventory = {};
  const availableColors = [];

  // Initialize colorInventory for all colors first
  allColors.forEach((color) => {
    colorInventory[color] = [];
  });

  // Fetch availability for each base handle with each color
  const availabilityPromises = [];

  for (const baseHandle of baseHandles) {
    // Check each standard color
    for (const color of allColors) {
      // Get the handle suffix for this color (e.g., "Blue" -> "blu")
      const handleSuffix = colorHandleMap[color] || color.toLowerCase();

      // Create the product handle with the appropriate suffix
      const colorHandle = `${baseHandle}-${handleSuffix}`;

      availabilityPromises.push(
        fetchProductByHandle(colorHandle)
          .then((result) => {
            if (!result.errors && result.product) {
              const product = result.product;

              // Check variant availability instead of product availability
              let isAvailable = false;
              if (product.variants && product.variants.length > 0) {
                // Use the first variant's availability
                isAvailable = product.variants[0].available === true;
              } else {
                isAvailable = product.available === true;
              }

              // Add to the color's inventory tracking
              if (!colorInventory[color]) {
                colorInventory[color] = [];
              }

              colorInventory[color].push({
                handle: colorHandle,
                available: isAvailable,
                baseHandle: baseHandle, // Store base handle for traceability
              });
            }
          })
          .catch((error) => {
            // Handle error silently
          })
      );
    }
  }

  // Wait for all availability checks to complete
  await Promise.allSettled(availabilityPromises);

  // IMPROVED LOGIC: A color is available if:
  // 1. For "front" build: At least one front wheel in that color is available
  // 2. For "rear" build: At least one rear wheel in that color is available
  // 3. For "complete" build: At least one complete set OR matching front+rear from different meta objects

  // Process each color to determine availability
  for (const color of allColors) {
    const colorProducts = colorInventory[color] || [];

    // Skip if no products for this color
    if (colorProducts.length === 0) {
      continue;
    }

    let isColorAvailable = false;

    if (queryParams.buildType === "front") {
      // For front builds, any available front product makes the color available
      isColorAvailable = colorProducts.some((item) => item.available);
    } else if (queryParams.buildType === "rear") {
      // For rear builds, any available rear product makes the color available
      isColorAvailable = colorProducts.some((item) => item.available);
    } else {
      // For complete builds - need to check if we can make a complete set

      // First check if any single meta object has a complete set available
      const baseHandleGroups = {};
      colorProducts.forEach((product) => {
        const baseHandle = product.baseHandle || "";
        if (!baseHandleGroups[baseHandle]) {
          baseHandleGroups[baseHandle] = [];
        }
        baseHandleGroups[baseHandle].push(product);
      });

      // Check each base handle group to see if it has availability
      for (const group of Object.values(baseHandleGroups)) {
        if (group.every((item) => item.available)) {
          isColorAvailable = true;
          break;
        }
      }

      // If no single meta object has a complete set available,
      // check if we can make a "virtual" complete set from different meta objects
      if (!isColorAvailable && baseHandles.length >= 2) {
        // Check for any available front wheel
        const hasAvailableFront = colorProducts.some(
          (item) => item.available && item.handle.includes("-front")
        );

        // Check for any available rear wheel
        const hasAvailableRear = colorProducts.some(
          (item) => item.available && item.handle.includes("-rear")
        );

        // If both front and rear are available (from any meta object), we have a valid set
        isColorAvailable = hasAvailableFront && hasAvailableRear;
      }
    }

    // Add to available colors if determined to be available
    if (isColorAvailable && !availableColors.includes(color)) {
      availableColors.push(color);
    }
  }

  // Sort the available colors
  availableColors.sort();

  return {
    hubInventory: colorInventory,
    availableColors: availableColors,
    baseHandles: baseHandles,
  };
}

// Debug logging function - set to true to enable logs
const DEBUG_FREEHUB = true;

function logFreeHub(message, data) {
  if (!DEBUG_FREEHUB) return;

  const timestamp = new Date().toISOString().substring(11, 19); // HH:MM:SS
  const formattedMsg = `[FreeHub ${timestamp}] ${message}`;

  if (data !== undefined) {
    console.log(formattedMsg, data);
  } else {
    console.log(formattedMsg);
  }
}

// Fetch freehub inventory information from metaobjects
async function fetchFreeHubInventory(hubModel) {
  let results = [];
  let hasMore = true;
  let cursor = null;

  logFreeHub("Starting freehub inventory fetch for hub model:", hubModel);

  // Format query parameters for consistency
  const queryParams = {
    hubModel: hubModel?.toLowerCase().trim() || "",
  };

  // Track availability of each driver type
  const driverAvailability = {
    XD: false,
    "XD Road": false,
    HG: false,
    Microspline: false,
  };

  // Fetch freehub inventory metaobjects
  while (hasMore) {
    logFreeHub("Fetching freehub inventory batch with cursor:", cursor);

    const { data, errors } = await _e.request(
      `query GetFreeHubInventory($type: String!, $entryCount: Int!, $cursor: String) {
        metaobjects(type: $type, first: $entryCount, after: $cursor) {
          edges {
            node {
              handle
              type
              fields {
                key
                value
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`,
      {
        variables: {
          type: "freehub_inventory",
          entryCount: 250,
          cursor,
        },
      }
    );

    if (errors) {
      logFreeHub("Error fetching freehub inventory:", errors);
      return { errors };
    }

    const { metaobjects } = data ?? {};
    const { edges, pageInfo } = metaobjects ?? {};
    if (edges) {
      logFreeHub(`Received ${edges.length} freehub inventory records in batch`);
      results = results.concat(edges.map((edge) => edge.node));
    }
    hasMore = pageInfo?.hasNextPage;
    cursor = pageInfo?.endCursor;
  }

  logFreeHub(`Total freehub inventory records fetched: ${results.length}`);

  // Helper function to normalize and compare strings
  function normalizeAndCompare(str1, str2) {
    // Handle null/undefined values
    if (!str1 || !str2) {
      logFreeHub("String comparison failed - null or undefined value", {
        str1,
        str2,
      });
      return false;
    }

    // Handle JSON array strings in metaobject fields (format: ["value"])
    let normalizedStr1 = str1;
    try {
      // Check if str1 is a JSON array string
      if (str1.trim().startsWith("[") && str1.trim().endsWith("]")) {
        const parsed = JSON.parse(str1);
        if (Array.isArray(parsed) && parsed.length > 0) {
          normalizedStr1 = parsed[0]; // Use the first value in the array
          logFreeHub("Parsed JSON array string:", {
            original: str1,
            parsed: normalizedStr1,
          });
        }
      }
    } catch (e) {
      logFreeHub("Error parsing JSON array string:", {
        str: str1,
        error: e.message,
      });
      // Continue with original string if parsing fails
    }

    // Normalize strings: lowercase, trim, remove extra spaces, normalize hyphens/dashes
    const normalize = (s) =>
      s.toLowerCase().trim().replace(/\s+/g, " ").replace(/[-–—]/g, "-");

    const normalizedStr1Final = normalize(normalizedStr1);
    const normalizedStr2 = normalize(str2);

    const match = normalizedStr1Final === normalizedStr2;
    if (match) {
      logFreeHub("String match found:", {
        original1: str1,
        original2: str2,
        normalized1: normalizedStr1Final,
        normalized2: normalizedStr2,
      });
    }

    // Compare normalized strings
    return match;
  }

  // Filter freehub inventory metaobjects based on selected hub model
  const matchingFreeHubs = results.filter((freehub) => {
    const freehubFields = {};
    freehub.fields.forEach((field) => {
      freehubFields[field.key] = field.value;
    });

    logFreeHub("Evaluating freehub record:", {
      handle: freehub.handle,
      model: freehubFields.hub_model,
      driver: freehubFields.driver,
    });

    // Match on hub model if provided
    const matchModel =
      !queryParams.hubModel ||
      normalizeAndCompare(freehubFields.hub_model, queryParams.hubModel);

    if (matchModel) {
      logFreeHub("MATCH FOUND for freehub record:", {
        handle: freehub.handle,
        model: freehubFields.hub_model,
      });
    }

    return matchModel;
  });

  logFreeHub(`Found ${matchingFreeHubs.length} matching freehub records`);

  // Check availability for each matching freehub
  const availabilityPromises = [];
  const productHandles = [];

  matchingFreeHubs.forEach((freehub) => {
    const freehubFields = {};
    freehub.fields.forEach((field) => {
      freehubFields[field.key] = field.value;
    });

    // Get the driver type and product handle
    const driverType = freehubFields.driver;
    const productHandle = freehubFields.freehub_handle;

    logFreeHub("Processing driver and handle:", {
      driver: driverType,
      handle: productHandle,
    });

    if (driverType && productHandle) {
      // Normalize the handle value if needed
      let handleValue = productHandle.trim();
      try {
        // Check if the value is a JSON array string
        if (handleValue.startsWith("[") && handleValue.endsWith("]")) {
          const parsed = JSON.parse(handleValue);
          if (Array.isArray(parsed) && parsed.length > 0) {
            // Use the first value in the array
            handleValue = parsed[0].trim();
            logFreeHub("Parsed handle from JSON array:", {
              original: productHandle,
              parsed: handleValue,
            });
          }
        }
      } catch (e) {
        logFreeHub("Error parsing handle from JSON:", {
          handle: productHandle,
          error: e.message,
        });
        // Continue with original string if parsing fails
      }

      // Add to product handles if not already there
      if (!productHandles.includes(handleValue)) {
        productHandles.push(handleValue);
        logFreeHub("Added product handle for availability check:", handleValue);
      }

      // Check product availability
      availabilityPromises.push(
        fetchProductByHandle(handleValue)
          .then((result) => {
            if (!result.errors && result.product) {
              const product = result.product;

              logFreeHub("Product availability check result:", {
                handle: handleValue,
                available: product.available || false,
                inventoryQuantity: product.inventory_quantity || 0,
                driver: driverType,
              });

              // Check variant availability first
              if (product.variants && product.variants.length > 0) {
                const variantAvailable = product.variants[0].available === true;
                logFreeHub("Using variant availability:", {
                  variantId: product.variants[0].id,
                  available: variantAvailable,
                });

                // Update the driver availability based on variant availability
                if (variantAvailable) {
                  const driverCode = driverType.toLowerCase();

                  // Improved driver type detection with more precise matching
                  if (
                    driverCode.includes("road") &&
                    driverCode.includes("xd")
                  ) {
                    driverAvailability["XD Road"] = true;
                    logFreeHub(
                      "Setting XD Road driver available based on variant availability for:",
                      handleValue
                    );
                  } else if (driverCode.includes("xd")) {
                    driverAvailability.XD = true;
                    logFreeHub(
                      "Setting XD driver available based on variant availability for:",
                      handleValue
                    );
                  } else if (driverCode.includes("hg")) {
                    driverAvailability.HG = true;
                    logFreeHub(
                      "Setting HG driver available based on variant availability for:",
                      handleValue
                    );
                  }
                  // Fix: Catch both ms and microspline in the check
                  else if (
                    driverCode.includes("ms") ||
                    driverCode.includes("micro")
                  ) {
                    driverAvailability.Microspline = true;
                    logFreeHub(
                      "Setting Microspline driver available based on variant availability for:",
                      handleValue
                    );
                  }
                }
              }
              // Fallback to product level availability if no variants
              else {
                const productAvailable = product.available === true;
                logFreeHub("Using product-level availability:", {
                  available: productAvailable,
                });

                if (productAvailable) {
                  const driverCode = driverType.toLowerCase();

                  if (driverCode.includes("xd")) {
                    driverAvailability.XD = true;
                    logFreeHub(
                      "Setting XD driver available based on product availability for:",
                      handleValue
                    );
                  } else if (driverCode.includes("hg")) {
                    driverAvailability.HG = true;
                    logFreeHub(
                      "Setting HG driver available based on product availability for:",
                      handleValue
                    );
                  } else if (
                    driverCode.includes("ms") ||
                    driverCode.includes("micro")
                  ) {
                    driverAvailability.Microspline = true;
                    logFreeHub(
                      "Setting Microspline driver available based on product availability for:",
                      handleValue
                    );
                  }
                }
              }
            }
          })
          .catch((error) => {
            // Don't log every 404 error as this clutters the console
            if (!error.message?.includes("404")) {
              logFreeHub("Exception during product fetch:", {
                handle: handleValue,
                error: error.message,
              });
            }
          })
      );
    }
  });

  logFreeHub(`Initiated ${availabilityPromises.length} availability checks`);

  // Wait for all availability checks to complete
  await Promise.allSettled(availabilityPromises);

  logFreeHub("All availability checks completed");
  logFreeHub("Final driver availability status:", driverAvailability);

  // Get a list of available driver types
  const availableDrivers = Object.keys(driverAvailability).filter(
    (driver) => driverAvailability[driver]
  );

  logFreeHub("Available drivers:", availableDrivers);

  return {
    freeHubInventory: matchingFreeHubs,
    availableDrivers: availableDrivers,
    productHandles: productHandles,
  };
}

// Alpine store: wheelBuilderTabs
const wheelBuilderTabs = ({ labels, model }) => ({
  selectedId: null,
  selectedTab: null,
  rules: [],
  fetchingRules: false,
  ruleFetchError: null,
  model: model, // Store the model explicitly as a property

  init() {
    this.$nextTick(() => this.select(this.$id("tab", 1)));
    this.fetchRules();
  },

  async fetchRules() {
    this.fetchingRules = true;
    this.ruleFetchError = null;

    try {
      const currentModel = this.model ? this.model.toLowerCase() : "";

      // Fetch both wheelset and rim rules in parallel
      const [wheelRes, rimRes] = await Promise.all([
        fetchRules("wheelset_rule", currentModel),
        fetchRules("rim_rule", currentModel),
      ]);

      if (wheelRes.errors || rimRes.errors) {
        throw new Error(wheelRes.errors || rimRes.errors);
      }

      // Store rules separately to handle them differently based on selected tab
      this.wheelsetRules = wheelRes.rules || [];
      this.rimRules = rimRes.rules || [];
      this.rules = [...this.wheelsetRules, ...this.rimRules];
    } catch (error) {
      this.ruleFetchError = `Error fetching rules: ${error.message}`;
    } finally {
      this.fetchingRules = false;
    }
  },

  // Add helper method to get relevant rules based on selected tab
  getRelevantRules() {
    return this.selectedTab === "rim" ? this.rimRules : this.wheelsetRules;
  },

  select(id) {
    const parts = id.split("-");
    const tabIndex = parts[parts.length - 1] - 1;
    this.selectedId = id;
    this.selectedTab = labels[tabIndex];
  },
  isSelected(id) {
    return this.selectedId === id;
  },
  whichChild(child, parent) {
    return Array.from(parent.children).indexOf(child) + 1;
  },
});

// Enhance the product fetching function with better error handling and retries
async function fetchProductByHandle(handle) {
  if (!handle) {
    console.warn("fetchProductByHandle called with empty handle");
    return { errors: ["Empty product handle provided"] };
  }

  // Use a cache parameter to avoid browser caching
  const nocache = Date.now();
  let url = `/products/${handle}.js?nocache=${nocache}`;

  try {
    // Create an AbortController to handle timeouts
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    const response = await fetch(url, {
      method: "GET",
      signal: controller.signal,
      headers: {
        Accept: "application/json",
      },
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      // Handle 404 and other errors without logging to console
      if (response.status === 404) {
        return {
          errors: [`Product not found: ${handle}`],
          product: {
            available: false,
            inventory_quantity: 0,
            variants: [{ available: false }],
          },
        };
      }
      return {
        errors: [`HTTP error ${response.status}: ${response.statusText}`],
        product: {
          available: false,
          inventory_quantity: 0,
          variants: [{ available: false }],
        },
      };
    }

    const product = await response.json();
    return { product };
  } catch (error) {
    // Don't log AbortError (timeouts) to avoid spamming the console
    if (error.name !== "AbortError") {
      console.warn(`Error fetching product ${handle}:`, error);
    }

    return {
      errors: [error.message || "Unknown error fetching product"],
      product: {
        available: false,
        inventory_quantity: 0,
        variants: [{ available: false }],
      },
    };
  }
}

// Add a small delay function to help with smooth transitions
async function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// Alpine store: wheelBuilderForm
const wheelBuilderForm = ({ optionKeys }) => ({
  completeOptions: optionKeys.map((key, i) => ({
    id: key,
    value: "",
    expanded: i === 0,
  })),
  products: { front: null, rear: null },
  unavailable: false,
  loading: false,
  isFetchingProducts: false,
  fetchingHubInventory: false, // Track hub inventory fetching state
  fetchingFreeHubInventory: false, // Track free hub inventory fetching state
  hasCompletedInventoryCheck: false,
  hasCompletedFreeHubCheck: false, // Track whether free hub check has been completed
  messageState: "initial", // New state property: 'initial', 'loading', 'available', 'unavailable'
  error: null,
  priceCalculated: false,
  hubInventory: null, // Store hub inventory data
  freeHubInventory: null, // Store free hub inventory data
  availableHubColors: [], // Store available hub colors
  availableDrivers: [], // Store available driver types
  showHubUnavailableMessage: false,
  showProductUnavailableMessage: false,
  loadingOperations: 0, // Track number of active loading operations
  loadingComplete: true, // Boolean flag for all loading completed
  hubColorsLoading: true, // Specific loading state for hub colors
  hubColorsInitialized: false, // Track if hub colors have been initialized

  async init() {
    // Initialize with empty visibility flags
    this.showHubUnavailableMessage = false;
    this.showProductUnavailableMessage = false;
    this.loadingOperations = 0;
    this.loadingComplete = true;
    this.hubColorsLoading = true; // Start with hub colors in loading state
    this.hubColorsInitialized = false;

    // Apply loading class to hub color options immediately on initialization
    this.$nextTick(() => {
      this.updateHubColorUI(true); // Apply loading UI to hub colors
    });

    this.watchOptions();

    // Set up watchers for message visibility
    this.$watch("loadingComplete", () => this.setMessageVisibility());
    this.$watch("hasCompletedInventoryCheck", () =>
      this.setMessageVisibility()
    );
    this.$watch("availableHubColors", () => this.setMessageVisibility());
    this.$watch("products", () => this.setMessageVisibility(), { deep: true });

    // Watch hub colors loading state for UI updates
    this.$watch("hubColorsLoading", (newValue) => {
      if (this.hubColorsInitialized || !newValue) {
        // Hub colors are no longer loading or have been initialized, update UI
        this.$nextTick(() => {
          this.updateHubColorUI(false);
        });
      }
    });
  },

  // Enhanced method to update hub color elements in UI with more reliable state management
  updateHubColorUI(isLoading = false) {
    // Find all hub color option elements
    const hubColorElements = document.querySelectorAll(
      '[data-option="hub_colour"]'
    );

    if (hubColorElements.length === 0) {
      return; // Skip if elements aren't found yet
    }

    this.hubColorsInitialized = true; // Mark as initialized since we found elements

    // Find the hub color accordion panel
    const hubColorPanel = document.querySelector(
      '[data-option-group="hub_colour"]'
    );

    // Determine loading state based on both parameter and system state
    const shouldShowLoading =
      isLoading ||
      this.fetchingHubInventory ||
      !this.hasCompletedInventoryCheck;

    // Apply or remove loading class based on loading state
    hubColorElements.forEach((element) => {
      if (shouldShowLoading) {
        // Add loading class
        element.classList.add("loading");

        // Create and add loading indicator if it doesn't exist
        let loadingIndicator = element.querySelector(
          ".color-loading-indicator"
        );
        if (!loadingIndicator) {
          loadingIndicator = document.createElement("div");
          loadingIndicator.className = "color-loading-indicator";
          loadingIndicator.innerHTML =
            '<div class="spinner"></div><span>Loading...</span>';

          // Add inline styles for the loading overlay
          loadingIndicator.style.cssText =
            "position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 100; border-radius: inherit; font-weight: bold; color: #333; font-size: 14px;";

          // Add spinner styles
          const spinner = loadingIndicator.querySelector(".spinner");
          spinner.style.cssText =
            "width: 30px; height: 30px; border: 4px solid rgba(0,0,0,0.2); border-top-color: #000; border-radius: 50%; animation: spin 0.8s linear infinite; margin-bottom: 10px;";

          // Add animation for spinner
          if (!document.getElementById("spinnerAnimation")) {
            const style = document.createElement("style");
            style.id = "spinnerAnimation";
            style.textContent =
              "@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }";
            document.head.appendChild(style);
          }

          // Ensure parent element has position relative for absolute positioning
          element.style.position = "relative";
          element.style.overflow = "hidden";

          // Add the loading indicator to the element
          element.appendChild(loadingIndicator);
        } else {
          // Show existing loading indicator
          loadingIndicator.style.display = "flex";
        }

        // Disable the element and any inputs it contains while loading
        element.setAttribute("aria-disabled", "true");
        const inputs = element.querySelectorAll("input, button, select");
        inputs.forEach((input) => {
          input.disabled = true;
          // Add an attribute to remember this was disabled by loading
          input.setAttribute("data-loading-disabled", "true");
        });
      } else {
        // Remove loading class
        element.classList.remove("loading");

        // Hide loading indicator if it exists
        const loadingIndicator = element.querySelector(
          ".color-loading-indicator"
        );
        if (loadingIndicator) {
          loadingIndicator.style.display = "none";
        }

        // Only enable inputs that were disabled by loading
        const inputs = element.querySelectorAll(
          "[data-loading-disabled='true']"
        );
        inputs.forEach((input) => {
          // Only enable if parent isn't otherwise disabled
          if (
            !element.classList.contains("disabled") &&
            !element.hasAttribute("disabled")
          ) {
            input.disabled = false;
            input.removeAttribute("data-loading-disabled");
          }
        });

        // Update ARIA attributes
        if (
          element.hasAttribute("disabled") ||
          element.classList.contains("disabled")
        ) {
          element.setAttribute("aria-disabled", "true");
        } else {
          element.setAttribute("aria-disabled", "false");
        }
      }
    });

    // Update loading state for the parent container, but without any message
    if (hubColorPanel) {
      if (shouldShowLoading) {
        hubColorPanel.classList.add("options-loading");
      } else {
        hubColorPanel.classList.remove("options-loading");
      }
    }
  },

  // New method to start a loading operation
  startLoading() {
    this.loadingOperations++;
    this.loadingComplete = false;

    // Hide all messages immediately when loading starts
    this.showHubUnavailableMessage = false;
    this.showProductUnavailableMessage = false;
  },

  // New method to end a loading operation
  endLoading() {
    if (this.loadingOperations > 0) {
      this.loadingOperations--;
    }

    if (this.loadingOperations === 0) {
      // Small delay to ensure all DOM updates are complete before changing visibility
      setTimeout(() => {
        this.loadingComplete = true;
      }, 100);
    }
  },

  formatPrice(value) {
    try {
      // Get the current shop domain to determine the correct currency
      const shopDomain = window.location.hostname;

      // More robust detection of USD site
      const isUSDomain =
        shopDomain.includes(".us") ||
        shopDomain.includes("us.") ||
        document.documentElement.getAttribute("data-currency") === "USD" ||
        (document.querySelector('meta[property="og:price:currency"]') &&
          document
            .querySelector('meta[property="og:price:currency"]')
            .getAttribute("content") === "USD");

      // Force USD for US sites regardless of what Shopify reports
      const currency = isUSDomain
        ? "USD"
        : window.Shopify?.currency?.active || "CAD";

      // Log currency detection for debugging
      console.log(
        `Currency detection - Domain: ${shopDomain}, isUSDomain: ${isUSDomain}, Using currency: ${currency}`
      );

      // Get the appropriate locale (fallback to en-US or en-CA)
      const locale = `${window.Shopify?.locale || "en"}-${
        isUSDomain ? "US" : "CA"
      }`;

      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
      }).format(value);
    } catch (error) {
      // Fallback formatting if anything fails
      console.error("Price formatting error:", error);
      return isUSDomain
        ? `$${value.toFixed(2)} USD`
        : `$${value.toFixed(2)} CAD`;
    }
  },

  get validationHint() {
    const empty = this.completeOptions.find((o) => o.value === "");
    return empty ? empty.id.replace(/_/g, " ") : "";
  },

  get pricing() {
    const { selectedTab } = this.$data;
    const frontV = this.products.front?.variant;
    const rearV = this.products.rear?.variant;

    // For complete wheelset, we need both front and rear to be loaded
    const isCompleteWheelset =
      selectedTab === "wheelset" || selectedTab === "complete";
    const needsBothWheels = isCompleteWheelset && (!frontV || !rearV);

    // If we're loading products or missing required wheels, return null prices
    if (this.isFetchingProducts || needsBothWheels) {
      return {
        price: null,
        compareAtPrice: null,
        loading: true,
      };
    }

    const frontPrice = Number(frontV?.price ?? 0);
    const rearPrice = Number(rearV?.price ?? 0);
    const frontCompare = Number(frontV?.compare_at_price ?? 0);
    const rearCompare = Number(rearV?.compare_at_price ?? 0);

    function sum(f, r) {
      if (selectedTab === "front") return f;
      if (selectedTab === "rear") return r;
      return f + r;
    }

    const p = sum(frontPrice, rearPrice) / 100;
    const c = sum(frontCompare, rearCompare) / 100;

    this.priceCalculated = true;
    return {
      price: p === 0 ? null : this.formatPrice(p),
      compareAtPrice: c === 0 ? null : this.formatPrice(c),
      loading: false,
    };
  },

  watchOptions() {
    let oldState = this.completeOptions.map((o) => ({ ...o }));
    this.$watch("completeOptions", (newVal) => {
      const changed = newVal.filter(
        (o, idx) => o.value !== oldState[idx].value
      );
      oldState = newVal.map((o) => ({ ...o }));
      if (!changed.every((c) => c.value === "")) {
        changed.forEach((c) => this.handleValueSet(c));
      }
    });
  },

  async handleValueSet(opt) {
    const idx = this.completeOptions.indexOf(opt) + 1;
    const nextOpt = this.completeOptions[idx];
    const hasAhead = this.completeOptions
      .slice(idx)
      .some((o) => o.value !== "");
    if (nextOpt) {
      if (hasAhead) {
        for (let i = idx; i < this.completeOptions.length; i++) {
          const sub = this.completeOptions[i];
          sub.value = "";
          sub.expanded = i === idx;
        }
      } else {
        this.$nextTick(() => {
          nextOpt.expanded = true;
        });
      }
      if (opt.value !== "") {
        const panel = this.$root.querySelector(
          `[data-option-group="${nextOpt.id}"]`
        );
        this.scrollToPanel(panel);
      }
    }

    // Apply loading state to hub colors immediately when critical parameters change
    if (
      ["hub_model", "brake_type", "front_spacing", "rear_spacing"].includes(
        opt.id
      )
    ) {
      this.hubColorsLoading = true;
      this.$nextTick(() => {
        this.updateHubColorUI(true);
      });
    }

    // Check if hub model or essential parameters have changed
    // to trigger hub inventory fetch
    if (
      ["hub_model", "brake_type", "front_spacing", "rear_spacing"].includes(
        opt.id
      )
    ) {
      await this.fetchAndSetHubInventory();
    }
    // Check if hub model has changed to trigger free hub inventory fetch
    if (opt.id === "hub_model") {
      await this.fetchAndSetFreeHubInventory();
    }

    const valid = this.filterRules();
    this.updateAvailableOptions(valid);
    await this.setSelectedProducts(valid);
  },

  // Updated method to fetch hub inventory information based on selected options
  async fetchAndSetHubInventory() {
    // Get the current selected tab
    const { selectedTab } = this.$data;

    // Skip hub inventory check entirely for rim tab since rims don't have hub colors
    if (selectedTab === "rim") {
      this.hubColorsLoading = false;
      this.hasCompletedInventoryCheck = true; // Mark as completed so we don't show loading
      this.$nextTick(() => {
        this.updateHubColorUI(false); // Update UI to show no loading state
      });
      return;
    }

    // Get the values of the required options for hub inventory
    const hubModel = this.getOptionById("hub_model")?.value;
    const brakeType = this.getOptionById("brake_type")?.value;
    const frontSpacing = this.getOptionById("front_spacing")?.value;
    const rearSpacing = this.getOptionById("rear_spacing")?.value;
    const frontRim = this.getOptionById("front_rim")?.value;
    const rearRim = this.getOptionById("rear_rim")?.value;

    // Set hub colors to loading state BEFORE any checks or rule applications
    this.hubColorsLoading = true;
    this.updateHubColorUI(true); // Apply loading UI to hub colors

    // Disable all hub color options immediately to prevent selection during loading
    const hubColorEls = document.querySelectorAll('[data-option="hub_colour"]');
    hubColorEls.forEach((el) => {
      el.disabled = true;
    });

    // Determine build type based on selected tab
    let buildType = "complete";
    if (selectedTab === "front") {
      buildType = "front";
    } else if (selectedTab === "rear") {
      buildType = "rear";
    }

    // Reset hub inventory and available colors
    this.hubInventory = null;
    this.availableHubColors = [];
    // Mark inventory check as incomplete
    this.hasCompletedInventoryCheck = false;

    // Skip actual fetch if we don't have the fetchHubInventory function
    if (!fetchHubInventory) {
      // Even without the fetch, maintain loading state for consistent appearance
      await delay(300); // Brief delay to show loading state
      this.hubColorsLoading = false;
      this.updateHubColorUI(false);
      return;
    }
    this.updateHubColorUI(true); // Apply loading UI to hub colors
    // Start loading operation
    this.startLoading();
    this.fetchingHubInventory = true;

    try {
      const { hubInventory, availableColors, baseHandles, errors } =
        await fetchHubInventory(
          hubModel,
          brakeType,
          frontSpacing,
          rearSpacing,
          buildType,
          frontRim,
          rearRim
        );

      if (errors) {
        console.error("Hub inventory fetch errors:", errors);
        this.hasCompletedInventoryCheck = true;
        return;
      }

      this.hubInventory = hubInventory;

      // Set available colors directly from the inventory results
      this.availableHubColors = Array.isArray(availableColors)
        ? availableColors
        : [];

      // Update hub color option immediately if currently selected color is unavailable
      const hubColorOption = this.getOptionById("hub_colour");
      if (hubColorOption && hubColorOption.value) {
        if (!this.availableHubColors.includes(hubColorOption.value)) {
          hubColorOption.value = "";
        }
      }

      // Ensure we apply valid rules AFTER updating inventory data
      const valid = this.filterRules();
      this.updateAvailableOptions(valid);

      // Add a small delay to ensure UI updates properly
      await delay(300);
    } catch (error) {
      console.error("Error fetching hub inventory:", error);
    } finally {
      // Always mark that we've completed the inventory check
      this.fetchingHubInventory = false;
      this.hasCompletedInventoryCheck = true;
      // Set hub colors to not loading - this will trigger the UI update
      this.hubColorsLoading = false;
      this.endLoading();
    }
  },

  // Fetch free hub inventory information based on selected hub model
  async fetchAndSetFreeHubInventory() {
    // Get the hub model value
    const hubModel = this.getOptionById("hub_model")?.value;

    // Reset free hub inventory and available drivers
    this.freeHubInventory = null;
    this.availableDrivers = [];

    // We still mark the free hub check as incomplete but don't show any warning
    if (!hubModel) {
      this.hasCompletedFreeHubCheck = false;
      return;
    }

    // Start loading operation
    this.startLoading();
    this.fetchingFreeHubInventory = true;

    try {
      const { freeHubInventory, availableDrivers, productHandles, errors } =
        await fetchFreeHubInventory(hubModel);

      if (errors) {
        this.hasCompletedFreeHubCheck = true;
        return;
      }

      // Store the inventory and available drivers
      this.freeHubInventory = freeHubInventory;
      this.availableDrivers = Array.isArray(availableDrivers)
        ? availableDrivers
        : [];

      // Update driver selections based on new availability
      this.updateDriverSelection();

      // Update available options to reflect new inventory status
      const valid = this.filterRules();
      this.updateAvailableOptions(valid);
    } catch (error) {
      console.error("Error fetching freehub inventory:", error);
    } finally {
      // Mark that we've completed the free hub check
      this.fetchingFreeHubInventory = false;
      this.hasCompletedFreeHubCheck = true;
      this.endLoading();
    }
  },

  scrollToPanel(el, behavior = "smooth") {
    if (el) el.scrollIntoView({ behavior, block: "center" });
  },

  filterRules() {
    const chosen = this.completeOptions.filter((o) => o.value !== "");
    const relevantRules = this.$data.getRelevantRules();
    return relevantRules.filter((rule) => {
      const relevant = rule.fields.filter((f) =>
        this.completeOptions.some((c) => c.id === f.key)
      );
      return chosen.every((opt) => {
        const match = relevant.find((f) => f.key === opt.id);
        return match?.value === opt.value;
      });
    });
  },

  updateAvailableOptions(validRules) {
    const allEls = [...this.$el.querySelectorAll("[data-option]")];

    // Process all elements excluding hub colors and drivers first
    allEls
      .filter(
        (el) =>
          this.completeOptions.some(
            (o) => o.id === el.dataset.option && o.value === ""
          ) &&
          el.dataset.option !== "hub_colour" &&
          el.dataset.option !== "driver_style"
      )
      .forEach((el) => {
        const { accordionPanelId } = Alpine.$data(el);
        const isOkayByRules = validRules.some((rule) =>
          rule.fields.find(
            (f) => f.key === accordionPanelId && f.value === el.value
          )
        );
        el.disabled = !isOkayByRules;
      });

    // Process hub colors specifically, considering both rules and inventory
    const hubColorEls = allEls.filter(
      (el) => el.dataset.option === "hub_colour"
    );

    if (hubColorEls.length) {
      // If we've done a hub inventory check and no colors are available, disable all colors
      const hasAvailableColors =
        this.availableHubColors && this.availableHubColors.length > 0;
      const hasCompletedInventoryCheck = this.hasCompletedInventoryCheck;

      hubColorEls.forEach((el) => {
        const { accordionPanelId } = Alpine.$data(el);
        const colorValue = el.value;

        // First check if it's valid according to the rules
        const isOkayByRules = validRules.some((rule) =>
          rule.fields.find(
            (f) => f.key === accordionPanelId && f.value === colorValue
          )
        );

        let isDisabled;

        // Prioritize inventory check for hub colors
        if (hasCompletedInventoryCheck) {
          // For hub colors, when inventory check is complete:
          // 1. If no colors are available, disable everything
          // 2. If colors are available, only enable those in inventory
          isDisabled = !this.availableHubColors.includes(colorValue);
        } else {
          // If we haven't done an inventory check yet, just use the rules
          isDisabled = !isOkayByRules;
        }

        // Set the disabled status
        el.disabled = isDisabled;
      });
    }

    // Process driver options specifically, considering both rules and inventory
    const driverEls = allEls.filter(
      (el) => el.dataset.option === "driver_style"
    );

    if (driverEls.length) {
      // Log the current driver state for debugging
      console.log("Driver availability check - current state:", {
        hasCompletedCheck: this.hasCompletedFreeHubCheck,
        availableDrivers: this.availableDrivers,
      });

      driverEls.forEach((el) => {
        const { accordionPanelId } = Alpine.$data(el);
        const driverValue = el.value;

        // First check if it's valid according to the rules
        const isOkayByRules = validRules.some((rule) =>
          rule.fields.find(
            (f) => f.key === accordionPanelId && f.value === driverValue
          )
        );

        let isDisabled;

        // Prioritize inventory check for drivers - EXACTLY like hub colors
        if (this.hasCompletedFreeHubCheck) {
          // Simple direct matching just like hub colors
          isDisabled = !this.availableDrivers.includes(driverValue);
          console.log(`Driver ${driverValue} availability check:`, {
            driverValue,
            available: !isDisabled,
            availableDrivers: this.availableDrivers,
            isInList: this.availableDrivers.includes(driverValue),
          });
        } else {
          // If we haven't done an inventory check yet, just use the rules
          isDisabled = !isOkayByRules;
        }

        // Set the disabled status
        el.disabled = isDisabled;

        // Ensure UI reflects disabled state by adding a data attribute
        if (isDisabled) {
          el.setAttribute("data-unavailable", "true");
        } else {
          el.removeAttribute("data-unavailable");
        }
      });
    }
  },

  resetProductsAndAvailability() {
    this.products.front = null;
    this.products.rear = null;
    this.unavailable = false;
    this.error = null;
    this.priceCalculated = false;
  },

  // Add method to format option labels
  formatLabel(id) {
    return id
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },

  async setSelectedProducts(matchedRules) {
    if (!this.isEveryOptionSelected()) {
      this.resetProductsAndAvailability();
      return;
    }

    // Reset price calculation state when fetching new products
    this.priceCalculated = false;

    // Start loading operation
    this.startLoading();
    this.isFetchingProducts = true;
    // Force hub colors to show loading state while products are being fetched
    this.hubColorsLoading = true;
    this.$nextTick(() => {
      this.updateHubColorUI(true);
    });

    // Store the current state of availableHubColors to prevent flickering
    const previousAvailableColors = [...this.availableHubColors];

    try {
      const { selectedTab } = this.$data;
      const getVal = (k) =>
        matchedRules[0]?.fields.find((f) => f.key === k)?.value;
      const getVar = (p) => {
        if (!p?.variants?.length && !p?.available) return null;
        // For products fetched via .js endpoint, the product itself is the variant
        if (!p.variants) {
          return {
            ...p,
            id: p.id,
            available: p.available,
            inventory_quantity: p.inventory_quantity,
            inventory_management: p.inventory_management,
            title: p.title,
            price: p.price,
            compare_at_price: p.compare_at_price,
          };
        }
        const variant = p.variants[0];
        return variant;
      };

      if (selectedTab === "rim") {
        const rimHandle = getVal("rim_product_handle");

        if (!rimHandle) {
          throw new Error("No rim product handle found in rules");
        }

        // Fetch the product directly without trying model-specific handles
        const result = await fetchProductByHandle(rimHandle);
        if (result.errors) {
          throw new Error(result.errors.message);
        }

        if (!result.product) {
          throw new Error("Rim product not found");
        }

        const variant = getVar(result.product);
        if (!variant) {
          throw new Error("No variant found for rim product");
        }

        this.products = {
          front: { ...result.product, variant },
          rear: null,
        };
      } else {
        // Wheelset handling - using the correct field names with "wheel" in them
        // Define the correct field names
        const frontFieldName = "front_wheel_product_handle";
        const rearFieldName = "rear_wheel_product_handle";

        // Check if we're building a complete wheelset
        const isCompleteBuild =
          selectedTab === "wheelset" || selectedTab === "complete";

        // Create an array to hold all product fetch promises
        const productFetchPromises = [];

        // Track front and rear results
        let frontResult = null;
        let rearResult = null;

        if (selectedTab === "front" || isCompleteBuild) {
          // Use the correct front wheel field name
          const frontHandle = getVal(frontFieldName);

          if (!frontHandle) {
            throw new Error(
              `No front wheel product handle found in rules (field: ${frontFieldName})`
            );
          }

          // Add front wheel fetch to promises
          productFetchPromises.push(
            fetchProductByHandle(frontHandle).then((result) => {
              frontResult = result;
              if (result.errors) {
                throw new Error(result.errors.message);
              }
              return result;
            })
          );
        }

        if (selectedTab === "rear" || isCompleteBuild) {
          // Use the correct rear wheel field name
          const rearHandle = getVal(rearFieldName);
          if (!rearHandle) {
            throw new Error(
              `No rear wheel product handle found in rules (field: ${rearFieldName})`
            );
          }

          // Add rear wheel fetch to promises
          productFetchPromises.push(
            fetchProductByHandle(rearHandle).then((result) => {
              rearResult = result;
              if (result.errors) {
                throw new Error(result.errors.message);
              }
              return result;
            })
          );
        }

        // Wait for all product fetches to complete
        await Promise.all(productFetchPromises);

        // Process front wheel result if we have one
        if (frontResult && frontResult.product) {
          const frontVariant = getVar(frontResult.product);
          if (!frontVariant) {
            throw new Error("No variant found for front wheel product");
          }
          this.products.front = {
            ...frontResult.product,
            variant: frontVariant,
          };
        }

        // Process rear wheel result if we have one
        if (rearResult && rearResult.product) {
          const rearVariant = getVar(rearResult.product);
          if (!rearVariant) {
            throw new Error("No variant found for rear wheel product");
          }
          this.products.rear = {
            ...rearResult.product,
            variant: rearVariant,
          };
        }
      }

      // After loading products, check if the selected hub color is available
      const hubColorOption = this.getOptionById("hub_colour");
      if (hubColorOption && hubColorOption.value) {
        // If the hub color is no longer available in inventory, reset it
        if (
          this.availableHubColors.length > 0 &&
          !this.availableHubColors.includes(hubColorOption.value)
        ) {
          hubColorOption.value = "";
        }
      }

      // Add a small delay before setting unavailable status to ensure UI transition is smooth
      await delay(300);
      this.unavailable = this.isUnavailable(
        this.products.front?.variant,
        this.products.rear?.variant
      );
    } catch (err) {
      this.error = err.message;
      this.resetProductsAndAvailability();
    } finally {
      // Always reset hubColorsLoading when done
      this.hubColorsLoading = false;
      this.$nextTick(() => {
        this.updateHubColorUI(false);
      });
      this.isFetchingProducts = false;
      this.endLoading();
      // Call setMessageVisibility to update any warning messages
      this.setMessageVisibility();
    }
  },

  async addToCart() {
    const { selectedTab } = this.$data;
    if (!this.isEveryOptionSelected()) {
      this.error = "Please select all options before adding to cart";
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      const items = [];
      const buildId = crypto.randomUUID();

      // Add selected options as properties
      const optionProperties = {
        _options: JSON.stringify(
          Object.fromEntries(
            this.completeOptions.map((o) => [this.formatLabel(o.id), o.value])
          )
        ),
      };

      const isCompleteBuild =
        selectedTab === "wheelset" || selectedTab === "complete";

      if (selectedTab === "rim") {
        // For rims, we only need the front product (which contains our rim)
        const rimVariant = this.products.front?.variant;
        if (!rimVariant) {
          throw new Error("No rim product selected");
        }

        items.push({
          id: rimVariant.id,
          quantity: 1,
          properties: optionProperties,
        });
      } else if (
        isCompleteBuild &&
        this.products.front?.variant &&
        this.products.rear?.variant
      ) {
        // Complete wheelset - add both front and rear
        items.push(
          {
            id: this.products.front.variant.id,
            quantity: 1,
            properties: { _wheelset: buildId, ...optionProperties },
          },
          {
            id: this.products.rear.variant.id,
            quantity: 1,
            properties: { _wheelset: buildId, ...optionProperties },
          }
        );
      } else if (selectedTab === "front" && this.products.front?.variant) {
        // Just front wheel
        items.push({
          id: this.products.front.variant.id,
          quantity: 1,
          properties: { _wheelset: buildId, ...optionProperties },
        });
      } else if (selectedTab === "rear" && this.products.rear?.variant) {
        // Just rear wheel
        items.push({
          id: this.products.rear.variant.id,
          quantity: 1,
          properties: { _wheelset: buildId, ...optionProperties },
        });
      }

      if (!items.length) {
        throw new Error("No products selected");
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || "Failed to add to cart");
      }

      // Dispatch cart build event
      document.dispatchEvent(new CustomEvent("cart:build"));

      // Update the cart count in the header (if it exists)
      this.updateCartCount();

      // Success! Clear the error and reset loading state
      this.error = null;
    } catch (err) {
      this.error = err.message || "Error adding to cart";
    } finally {
      this.loading = false;
    }
  },

  // Method to update the cart count in header
  updateCartCount() {
    // Try to refresh the cart count display in the header
    try {
      // If Shopify has a cart API available, use it to update the count
      if (window.Shopify && window.Shopify.updateCartInfo) {
        window.Shopify.updateCartInfo();
        return;
      }

      // Otherwise, fetch the cart and update any cart count elements
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((response) => response.json())
        .then((cart) => {
          // Find cart count elements and update them
          const cartCountElements = document.querySelectorAll(
            ".cart-count-bubble, .cart-count"
          );
          cartCountElements.forEach((element) => {
            // Update the text or content depending on the element type
            if (element.tagName === "SPAN") {
              element.textContent = cart.item_count;
            } else {
              // For more complex elements, try to find the count span inside
              const countSpan = element.querySelector("span");
              if (countSpan) countSpan.textContent = cart.item_count;
            }

            // Make sure the element is visible
            element.style.display =
              cart.item_count > 0 ? "inline-flex" : "none";
          });
        })
        .catch((error) => console.warn("Could not update cart count:", error));
    } catch (error) {
      console.warn("Error updating cart count:", error);
    }
  },

  getOptionById(id) {
    return this.completeOptions.find((o) => o.id === id) || {};
  },

  isUnavailable(frontVar, rearVar) {
    const { selectedTab } = this.$data;

    // Handle rim tab specially - only need to check front variant (which contains our rim)
    if (selectedTab === "rim") {
      return !frontVar?.available;
    }

    // For wheelset products
    if (selectedTab === "front") {
      return !frontVar?.available;
    } else if (selectedTab === "rear") {
      return !rearVar?.available;
    } else {
      // For complete wheelset, BOTH front AND rear must be available
      // So it's unavailable if EITHER is unavailable
      const frontUnavailable = !frontVar?.available;
      const rearUnavailable = !rearVar?.available;
      const isUnavailable = frontUnavailable || rearUnavailable;
      return isUnavailable;
    }
  },

  isEveryOptionSelected() {
    return this.completeOptions.every((o) => o.value !== "");
  },

  isInputGroupDisabled(key) {
    const found = this.getOptionById(key);
    const idx = this.completeOptions.indexOf(found);
    if (idx === 0) return false;
    return this.completeOptions[idx - 1].value === "";
  },

  clearSelections() {
    this.completeOptions.forEach((o, i) => {
      o.value = "";
      o.expanded = i === 0;
    });
    this.resetProductsAndAvailability();
    this.hubInventory = null;
    this.availableHubColors = [];
    const panel = this.$root.querySelector("[data-option-group]");
    this.scrollToPanel(panel, "instant");
  },

  // Updated method to set message visibility flags directly
  setMessageVisibility() {
    // Start by hiding all messages
    this.showHubUnavailableMessage = false;
    this.showProductUnavailableMessage = false;

    // Get the current selected tab
    const { selectedTab } = this.$data;

    // Skip hub availability checks entirely for rim tab
    if (selectedTab === "rim") {
      // For rim tab, only check product availability
      if (
        this.products.front?.variant &&
        !this.products.front.variant.available
      ) {
        this.showProductUnavailableMessage = true;
      }
      return;
    }

    // Don't show any messages during loading or initialization
    if (
      !this.loadingComplete ||
      this.loadingOperations > 0 ||
      this.fetchingHubInventory ||
      this.isFetchingProducts ||
      !this.hasCompletedInventoryCheck
    ) {
      return;
    }

    // For Hadley hub model in front tab, only check hub colors availability, not drivers
    const hubModel = this.getOptionById("hub_model")?.value;
    if (selectedTab === "front") {
      // Only show hub unavailable message if we have no available colors
      if (
        this.hasCompletedInventoryCheck &&
        (!this.availableHubColors || this.availableHubColors.length === 0)
      ) {
        this.showHubUnavailableMessage = true;
      }
    } else {
      // Check if all driver styles are unavailable (disabled)
      if (
        this.hasCompletedFreeHubCheck &&
        this.availableDrivers &&
        this.availableDrivers.length === 0
      ) {
        this.showHubUnavailableMessage = true;
        return;
      }
    }

    // Only proceed if we have completed inventory check and loading is complete
    // Hub colors unavailable message
    if (!this.availableHubColors || this.availableHubColors.length === 0) {
      this.showHubUnavailableMessage = true;
      return;
    }

    // Product unavailable message
    if (selectedTab === "front" || selectedTab === "complete") {
      if (
        this.products.front?.variant &&
        !this.products.front.variant.available
      ) {
        this.showProductUnavailableMessage = true;
        return;
      }
    }

    if (selectedTab === "rear" || selectedTab === "complete") {
      if (
        this.products.rear?.variant &&
        !this.products.rear.variant.available
      ) {
        this.showProductUnavailableMessage = true;
        return;
      }
    }
  },

  // Add method to update driver selection when availability changes
  updateDriverSelection() {
    // Get the current driver option
    const driverOption = this.getOptionById("driver");

    // If there is no driver option or it's not set, nothing to update
    if (!driverOption || !driverOption.value) {
      return;
    }

    // If we haven't completed a freehub check, don't update anything
    if (!this.hasCompletedFreeHubCheck) {
      return;
    }

    // If the driver is no longer available, reset it
    if (
      this.availableDrivers &&
      this.availableDrivers.length > 0 &&
      !this.availableDrivers.includes(driverOption.value)
    ) {
      console.log(
        `Driver ${driverOption.value} is no longer available. Resetting selection.`
      );
      driverOption.value = "";
      // Update the UI to show available options
      this.$nextTick(() => {
        const valid = this.filterRules();
        this.updateAvailableOptions(valid);
      });
    }
  },
});

function Q(name, store) {
  if (window.Alpine) {
    Alpine.data(name, store);
  } else {
    document.addEventListener("alpine:init", () => {
      Alpine.data(name, store);
    });
  }
}

Q("wheelBuilderTabs", wheelBuilderTabs);
Q("wheelBuilderForm", wheelBuilderForm);
